import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExternalApiService } from '../../../../../../services/external-api.service';
import { ViewsService } from '../../../../../../../services/views.service';

@Component({
    selector: 'cv-schema-render-rule-feedback',
    templateUrl: 'rule-feedback.component.html'
})
export class RuleFeedbackComponent {
    @Input() ruleSetId!: string;
    @Input() ruleId!: string;
    @Output() feedbackSuccess = new EventEmitter<void>();

    public feedbackForm!: FormGroup;
    public feedbackLoading = false;
    public success = false;
    public errorMessage!: string | null;
	public successMessage!: string | null;

	get order(): any {
		return this.viewsService.order;
	}

    constructor(
		private formBuilder: FormBuilder,
		private viewsService: ViewsService,
		private externalApiService: ExternalApiService,
	) {
        this.feedbackForm = formBuilder.group({
            feedback: ['', Validators.required]
        })
    }

    /**
     * Sends the entered rule feedback.
     */
    public onFeedBackSend(){
        if(this.feedbackForm.invalid) return;
        if(!this.ruleSetId || !this.order.id || !this.ruleId) return;
        const feedback = this.feedbackForm.get('feedback')?.value;

        this.feedbackLoading = true;
        this.success = false;
        this.errorMessage = null;

        this.externalApiService.sendRuleFeedBack(this.order.id, this.ruleSetId, this.ruleId, feedback).subscribe({
            next: () => {
                this.feedbackLoading = false;
                this.success = true;
				this.successMessage = 'Thank you for your feedback!';
                this.feedbackForm.get('feedback')?.setValue('');
                this.feedbackForm.get('feedback')?.disable();
                setTimeout(() => {
                    this.feedbackSuccess.emit();
                }, 2000)
            },
            error: () => {
                this.feedbackLoading = false;
                this.errorMessage = 'There was an error sending feedback. Please try again.';
            }
        })
    }
}
